import React from "react";
import './privacypolicy.css';

function FBDataDeletionUrl (){

    const openNewTab =(url)=>{
        window.open(url, '_blank')
    }
    return (
<div>
    <h3>Facebook Data Deletion Instructions</h3>
    <p>
      If you wish to delete your data associated with the app <strong>Etransport Fiji</strong>, you can follow these instructions:
    </p>
    <p>
      Since this app uses Facebook Login, you can remove your data by following these steps:
    </p>
    <ol>
      <li>Log into your Facebook account.</li>
      <li>Go to Settings &gt; Apps and Websites.</li>
      <li>Find and select <strong>Etransport Fiji</strong>.</li>
      <li>Click on <strong>Remove</strong> to disconnect the app.</li>
      <li>After confirming removal, any personal data stored by the app will be scheduled for deletion.</li>
    </ol>
  </div>
    )
}

export default FBDataDeletionUrl;